export default "__VITE_ASSET__B9wPS05B__"